
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"25","width":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#111224","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1.898 3.363c-.735 0-1.307.58-1.307 1.327s.572 1.328 1.307 1.328h20.261V3.363z"}}),_c('path',{attrs:{"d":"M0 23.104c0 .893.725 1.612 1.625 1.612h22.75c.9 0 1.625-.719 1.625-1.612v-2.902H15.925a1.63 1.63 0 01-1.625-1.613v-5.16a1.63 1.63 0 011.625-1.612H26V8.915c0-.894-.725-1.613-1.625-1.613l-22.73-.02A2.604 2.604 0 010 6.426zm15.925-9.997a.31.31 0 00-.325.322v5.16c0 .19.134.323.325.323H26v-5.805z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M18.206.732l.024 5.867H4.8L4.793.716l13.412.016z","stroke":"#fff","stroke-width":"1.073"}})])])
          )
        }
      }
    